import React from 'react';
import Carousel from '../carousel/carousel';
import UploadFile from '../uploadfile/uploadfile';
import Card from '../post/card';




class Mantra1 extends React.Component {
    render() {
        return (
            <div>
                <Carousel />
                <UploadFile />
                <Card />

            </div>

        )
    }
}

export default Mantra1;